<div class="row" *ngIf="isComercial">
    <div class="col-md col-xs col-xl col-sm wd-100-pc">
        <mat-card class="mat-elevation-z8 wd-100-pc">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Semente boa no descarte em 10 segundos (g)
                                </mat-label>
                                <input matInput id="txtSemBoaDezSegG" #txtSemBoaDezSegG maxlength="10"
                                    formControlName="semente_boa_dez_segundos_g" currencyMask readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtSemBoaDezSegG.value.length}} / 10
                                </mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.semente_boa_dez_segundos_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Perda Boa (%)
                                </mat-label>
                                <input matInput id="txtPerdaBoaPrc" #txtPerdaBoaPrc maxlength="10"
                                    formControlName="perda_boa_prc" currencyMask readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPerdaBoaPrc.value.length}} / 10
                                </mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.perda_boa_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Defeitos (%)
                                </mat-label>
                                <input matInput id="txtDefeitosPrc" #txtDefeitosPrc maxlength="10"
                                    formControlName="defeitos_prc" currencyMask readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDefeitosPrc.value.length}} / 10
                                </mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.defeitos_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Descarte Total (%)
                                </mat-label>
                                <input matInput id="txtDescTotalPrc" #txtDescTotalPrc maxlength="10"
                                    formControlName="descarte_total_prc" currencyMask readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDescTotalPrc.value.length}} / 10
                                </mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.descarte_total_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>
